'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { motion } from 'framer-motion';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-border mt-auto">
      <div className="container-custom py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and About */}
          <div className="space-y-4">
            <div className="relative h-14 w-40">
              <Image
                src="/logo.png"
                alt="Qmin"
                fill
                className="object-contain"
              />
            </div>
            <p className="text-gray-600 text-sm mt-4">
              Premium food delivery service. Bringing your favorite Qmin hotel cuisines to your doorstep.
            </p>
            <div className="flex space-x-4 mt-4">
              <motion.a
                href="https://www.facebook.com/QminApp/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-primary transition-colors"
                whileHover={{ scale: 1.1 }}
              >
                <Facebook size={18} />
              </motion.a>
              <motion.a
                href="https://x.com/QminApp/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-primary transition-colors"
                whileHover={{ scale: 1.1 }}
              >
                <Twitter size={18} />
              </motion.a>
              <motion.a
                href="https://www.instagram.com/qminapp/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-primary transition-colors"
                whileHover={{ scale: 1.1 }}
              >
                <Instagram size={18} />
              </motion.a>
              {/* <motion.a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-primary transition-colors"
                whileHover={{ scale: 1.1 }}
              >
                <Linkedin size={18} />
              </motion.a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { name: 'Home', href: '/' },
                { name: 'Restaurants', href: '/restaurants' },
                // { name: 'Offers', href: '/offers' },
                // { name: 'About Us', href: '/about' },
                // { name: 'Blog', href: '/blog' },
                { name: 'Contact', href: '/support' },
              ].map((link) => (
                <li key={link.name}>
                  <Link 
                    href={link.href}
                    className="text-gray-600 hover:text-primary transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Help & Support */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Help & Support</h4>
            <ul className="space-y-2">
              {[
                { name: 'Terms and conditions', href: 'https://www.qmin.co.in/terms-and-conditions' },
                { name: 'Privacy Policy', href: 'https://www.qmin.co.in/privacy-policy' },
                { name: 'Refund Policy', href: 'https://www.qmin.co.in/privacy-policy' },
              ].map((link) => (
                <li key={link.name}>
                  <Link 
                    href={link.href}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-600 hover:text-primary transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              {/* <li className="flex items-start">
                <MapPin className="h-5 w-5 text-primary mr-2 mt-0.5" />
                <span className="text-gray-600">
                  Tata HQ, Fort, Mumbai, Maharashtra, India
                </span>
              </li> */}
              <li className="flex items-center">
                <Phone className="h-5 w-5 text-primary mr-2" />
                <a 
                  href="tel:18002028282" 
                  className="text-gray-600 hover:text-primary transition-colors"
                >
                  1800-202-8282
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 text-primary mr-2" />
                <a 
                  href="mailto:customercare@tataneu.com" 
                  className="text-gray-600 hover:text-primary transition-colors"
                >
                   customercare@tataneu.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Qmin. All Rights Reserved.
          </p>
          <div className="mt-4 md:mt-0"> 
            <ul className="flex space-x-6">
            <li>
              <a 
                href="https://www.qmin.co.in/terms-and-conditions"
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-primary text-sm transition-colors"
              >
                Terms
              </a>
            </li>
            <li>
              <a 
                href="https://www.qmin.co.in/privacy-policy"
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-primary text-sm transition-colors"
              >
                Privacy
              </a>
            </li>
              {/* <li>
                <Link 
                  href="/cookies"
                  className="text-gray-500 hover:text-primary text-sm transition-colors"
                >
                  Cookies
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
